<template>
  <div class="step-finish">
    <h2 class="title">Finalizar consulta em lote</h2>
    <p class="description">Antes de finalizar a consulta em lote é importante verificar os custos.</p>

    <p class="description">Tornar essa consulta recorrente?: <b>{{ form.recurrent ? 'Sim' : 'Não' }}</b></p>
    <p class="description" v-if="form.recurrent">Periodicidade: <b>{{ findPeriodicitiy(form.periodicity).label }}</b></p>

    <p><b>Valor total estimado (R$): {{ total | currency }}</b></p>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import currency from '@/support/filters/currency';

export default {
  name: 'StepFinish',

  props: {
    tag: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },

  model: {
    prop: 'form',
    event: 'input',
  },

  data() {
    return {
    };
  },

  filters: {
    currency,
  },

  methods: {
    findPeriodicitiy(value) {
      return this.periodicities.find((periodicity) => periodicity.value === value);
    },
  },

  computed: {
    ...mapState('template', {
      template: 'template',
    }),
    ...mapState('recurrent', {
      periodicities: 'periodicities',
    }),
    ...mapState('batch', {
      total: 'total',
    }),
  },
};
</script>

<style lang="scss" scoped>
.step-finish {
  > .title {
    @apply text-3xl;
    @apply text-center;
  }

  > .description {
    @apply pb-4;
    @apply text-sm;
    @apply text-center;
  }
}
</style>
